import { render } from "./TanpaBilManual.vue?vue&type=template&id=2540fa5a"
import script from "./TanpaBilManual.vue?vue&type=script&lang=js"
export * from "./TanpaBilManual.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__